import styled from 'styled-components'
import { theme } from 'styles/theme/hav-theme'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.lg};
  width: 100%;
`

export const Description = styled.p`
  margin: 0;
  width: 100%;
  line-height: ${theme.typography.lineHeight.md};
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes.sm};
`
